import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BarkLogo from "./BarkLogo";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/mission", label: "Mission" },
  { to: "/beta", label: "Join the Android Beta" },
  { to: "/support", label: "Support" },
];

export default function SiteHeader() {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md bg-white/70 border-b border-white/60"
      data-testid="site-header"
    >
      <div className="mx-auto max-w-6xl px-5 md:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" className="no-underline" data-testid="header-logo-link">
          <BarkLogo size={40} />
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav-desktop">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `text-[15px] font-semibold transition-colors duration-200 ${
                  isActive
                    ? "text-bark-teal"
                    : "text-bark-ink hover:text-bark-teal"
                }`
              }
              data-testid={`nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {it.label}
            </NavLink>
          ))}
          <Link
            to="/beta"
            className="inline-flex items-center rounded-full bg-bark-teal px-5 py-2.5 text-white font-bold text-[14px] shadow-bark-soft transition-transform duration-200 hover:bg-bark-teal-hover hover:-translate-y-0.5"
            data-testid="header-cta-join-beta"
          >
            Join the Android Beta
          </Link>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center rounded-full p-2 text-bark-ink hover:bg-bark-teal-soft transition-colors"
          aria-label="Toggle menu"
          data-testid="header-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/60 bg-white/95" data-testid="header-nav-mobile">
          <div className="mx-auto max-w-6xl px-5 py-3 flex flex-col gap-1">
            {navItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-xl text-[15px] font-semibold ${
                    isActive
                      ? "bg-bark-teal-soft text-bark-teal"
                      : "text-bark-ink hover:bg-bark-teal-soft"
                  }`
                }
                data-testid={`nav-mobile-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {it.label}
              </NavLink>
            ))}
            <Link
              to="/beta"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-full bg-bark-teal px-5 py-3 text-white font-bold text-[15px]"
              data-testid="header-mobile-cta"
            >
              Join the Android Beta
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
